import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_015",
  "use": "icon-su_015-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_015\"><defs><style>#icon-su_015 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_015_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_015_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M12,5V2L6,6l6,4V7A6,6,0,1,1,7.31,9.27L5.64,8.16A8,8,0,1,0,12,5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol